module.exports = __webpack_public_path__ + "img/banner_font.82ca783e.png";